import React, { useEffect } from 'react';
import { getAdSenseClient, isAdSenseEnabled } from '../config/googleAds';

/**
 * Loads the AdSense script once for the SPA — after idle so it never competes
 * with first map paint. Required for Auto ads and manual units.
 */
const AdSenseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useEffect(() => {
        const client = getAdSenseClient();
        if (!client) return;
        if (document.querySelector('script[data-empire-adsense]')) return;

        const inject = () => {
            if (document.querySelector('script[data-empire-adsense]')) return;

            const script = document.createElement('script');
            script.async = true;
            script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
            script.crossOrigin = 'anonymous';
            script.dataset.empireAdsense = '1';
            document.head.appendChild(script);

            if (!document.querySelector('meta[name="google-adsense-account"]')) {
                const meta = document.createElement('meta');
                meta.name = 'google-adsense-account';
                meta.content = client;
                document.head.appendChild(meta);
            }
        };

        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(() => inject(), { timeout: 5000 });
        } else {
            window.setTimeout(inject, 3000);
        }
    }, []);

    if (!isAdSenseEnabled()) {
        return <>{children}</>;
    }

    return <>{children}</>;
};

export default AdSenseProvider;
